import { pick } from 'lodash';

const isDev = process.env.NODE_ENV === 'development';

/**
* Loads json files from passed require.context and returns data object
* @param {Function} getTemplates - result of a `require.context` call for json templates
* @param {Function} getPrefill - result of a `require.context` call for json prefill
* @returns {Object} Contents of all automatically imported json files grouped under `templates` and `prefill` keys
*/
export const importJsonData = (getTemplates, getPrefill) => {
  const data = { templates: {} };
  getTemplates.keys().forEach(filePath => {
    const name = filePath
      .replace('./', '')
      .replace('.json', '');

    data.templates[name] = getTemplates(filePath);
  });
  if (getPrefill) {
    data.prefill = {};
    getPrefill.keys().forEach(filePath => {
      const name = filePath
        .replace('./', '')
        .replace('.json', '');

      data.prefill[name] = getPrefill(filePath);
    });
  }

  return data;
};

/**
* Creates `getData` function with templates and prefill in closure
* @param {Object} templates - contains templates for steps and other entities used on the form
* @param {Object} prefill - contains prefilled data for steps and other entities (used only in dev mode)
* @returns {Function} `getData` function which returns merged data
*/
export const initGetData = (templates, prefill) => {
  return (fileNames, extraLogic) => {
    const fileNamesArray = Array.isArray(fileNames) ? fileNames : [fileNames];

    return Object.assign.apply(
      null,
      [
        {},
        ...fileNamesArray.map(fileName => templates[fileName]),
        ...fileNamesArray.map(fileName => pick((isDev && prefill[fileName]) ? prefill[fileName] : {}, Object.keys(templates[fileName]))),
        extraLogic || {},
      ],
    );
  };
};
